if (!customElements.get('cm-product-rotating-text')) {
  class CmProductRotatingText extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedAndReady) return;

      this.items = Array.from(this.querySelectorAll('.product__rotating-text-item'));
      this.currentIndex = Math.max(
        0,
        this.items.findIndex((item) => item.classList.contains('is-active'))
      );
      this.interval = Math.max(2000, Number(this.dataset.interval) || 4000);
      this.isVisible = typeof IntersectionObserver === 'undefined';
      this.isTransitioning = false;
      this.isConnectedAndReady = true;

      this.handleVisibilityChange = this.syncTimer.bind(this);
      this.handleMotionChange = this.syncTimer.bind(this);
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      this.motionQuery.addEventListener?.('change', this.handleMotionChange);

      if (this.items.length < 2) return;

      if (typeof IntersectionObserver !== 'undefined') {
        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            this.isVisible = entry.isIntersecting;
            this.syncTimer();
          },
          { threshold: 0.01 }
        );
        this.visibilityObserver.observe(this);
      }

      this.syncTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
      window.clearTimeout(this.transitionTimer);
      this.visibilityObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      this.motionQuery?.removeEventListener?.('change', this.handleMotionChange);
      this.isConnectedAndReady = false;
    }

    syncTimer() {
      const shouldRotate =
        this.items?.length > 1 && this.isVisible && !document.hidden && !this.motionQuery.matches;

      if (shouldRotate) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    }

    startTimer() {
      if (this.rotationTimer) return;
      this.rotationTimer = window.setInterval(() => this.showNext(), this.interval);
    }

    stopTimer() {
      window.clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }

    showNext() {
      if (this.isTransitioning || this.items.length < 2) return;

      const currentItem = this.items[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.items.length;
      const nextItem = this.items[nextIndex];

      this.isTransitioning = true;
      currentItem.classList.remove('is-active');
      currentItem.classList.add('is-leaving');
      currentItem.setAttribute('aria-hidden', 'true');
      nextItem.classList.add('is-entering');
      nextItem.removeAttribute('aria-hidden');

      this.transitionTimer = window.setTimeout(() => {
        currentItem.classList.remove('is-leaving');
        nextItem.classList.remove('is-entering');
        nextItem.classList.add('is-active');
        this.currentIndex = nextIndex;
        this.isTransitioning = false;
      }, 440);
    }
  }

  customElements.define('cm-product-rotating-text', CmProductRotatingText);
}
